import { Component, OnInit, ViewChild, ElementRef, Input, ComponentRef } from '@angular/core';
import { DataTransferService } from '../../../core/services/data-transfer.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../core/services/api.service';
import { GlobalService } from '../../../core/services/global.service';
import { ToastrService } from 'ngx-toastr';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-location-modal',
  templateUrl: './location-modal.component.html',
  styleUrls: ['./location-modal.component.scss']
})
export class LocationModal implements OnInit {

  title;
  formType;
  locationName: any;
  selectedLocation = {
    location_name: '',
    name: '',
    placeId: '',
    reference: ''
  };
  location_id;
  updateLocationAddress;
  selectedEmployee: any;
  employeeList = [];
  displayControl = false;
  @ViewChild('searchOrigin')
  searchOriginElementRef: ElementRef;
  employee_list: any;
  apiResult = false;
  showSavedLoc = false;
  @ViewChild('locationModal') locationModal: ElementRef;

  constructor(
    private dataTransferService: DataTransferService,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private globalService: GlobalService,
    private toastr: ToastrService) {

    this.formType = 0;
  }

  handleAddressChange(address: Address) {
  }

  ngOnInit() {
    this.displayControl = false;
    this.locationName = '';
    this.updateLocationAddress = '12qw';
    this.initializeCode();
  }

  ngOnChanges() {
  }

  ngOnDestroy() {
    this.locationName = '';
    this.selectedLocation = {
      location_name: '',
      name: '',
      placeId: '',
      reference: ''
    };
    this.dataTransferService.updateEditLocation('initialState');
  }

  initializeCode() {

    this.dataTransferService.getAddLocation().subscribe(
      value => {
        if (value != 'initialState') {
          this.formType = 0;
          this.showSavedLoc = true;
          this.title = 'Add Location';
          this.selectedEmployee = localStorage.getItem('userId');
          this.locationName = '';
          this.updateLocationAddress = '';
        }
      }
    );

    this.dataTransferService.getPassLocation().subscribe(
      value => {
        if (value != 'initialState') {
          this.formType = 1;
          this.showSavedLoc = false;
          this.location_id = value.location_id;
          this.updateLocationAddress = value.location_address;
          this.title = 'Edit Location';
          this.employee_list = this.getEmployeeList();
          this.selectedEmployee = value.user_id;
          this.locationName = value.location_name;
          this.selectedLocation.location_name = value.location_address;
          this.selectedLocation.placeId = value.place_id;
        }
      }
    );
    this.getEmployeeList();
  }

  private getEmployeeList() {

    this.globalService.showSpinner();
    this.apiService.getEmployeeList().subscribe(
      resp => {
        this.globalService.hideSpinner();
        if (resp.status == 1) {
          this.employeeList = resp.data;
        } else if (resp.status == 0) {
          this.toastr.clear();
          this.toastr.error(resp.message, 'Error');
        } else {
          this.toastr.clear();
          this.toastr.warning(resp.message, 'Warning');
        }
      },
      error => {
        this.globalService.hideSpinner();
        this.toastr.clear();
        this.toastr.warning(error.message, 'Warning');
      }
    );
    return (this.employeeList);
  }

  add() {
    this.dataTransferService.updateAddLocation(1);
  }

  onLocationSelected(location) {
    this.selectedLocation = location;
  }

  onSubmit() {

    if (this.formType == 0) {
      if (this.locationName == '') {
        this.toastr.clear();
        this.toastr.warning('Location name cannot be empty', 'Warning');
      } else if (this.selectedLocation.location_name == '') {
        this.toastr.clear();
        this.toastr.warning('Location address cannot be empty', 'Warning');
      } else {
        this.globalService.showSpinner();
        const obj = {
          'userId': this.selectedEmployee,
          'locationName': this.locationName,
          'locationAddress': this.selectedLocation.location_name,
          'placeId': this.selectedLocation.placeId
        };
        this.addLocation(obj);
      }
    } else {
      if (this.locationName == '') {
        this.toastr.clear();
        this.toastr.warning('Location name cannot be empty', 'Warning');
      } else if (this.selectedLocation.location_name == '') {
        this.toastr.clear();
        this.toastr.warning('Location address cannot be empty', 'Warning');
      } else {
        this.globalService.showSpinner();
        const updateObj = {
          'userId': this.selectedEmployee,
          'locationName': this.locationName,
          'locationAddress': this.selectedLocation.location_name,
          'placeId': this.selectedLocation.placeId,
          'locationId': this.location_id
        };
        this.editLocation(updateObj);
      }
    }
  }

  addLocation(obj) {

    this.apiService.saveLocation(obj).subscribe(
      resp => {
        this.globalService.hideSpinner();
        if (resp.status == 1) {
          this.locationName = '';
          this.updateLocationAddress = '';
          this.selectedLocation = {
            location_name: '',
            name: '',
            placeId: '',
            reference: ''
          };
          this.toastr.clear();
          this.toastr.success(resp.message, 'Success');
          this.locationModal.nativeElement.click();
          this.dataTransferService.updateEditLocation(1);
        } else {
          this.toastr.clear();
          this.toastr.error(resp.message, 'Error');
        }
      },
      error => {
        this.globalService.hideSpinner();
        this.toastr.clear();
        this.toastr.warning(error.message, 'Warning');
      }
    );
  }

  editLocation(obj) {

    this.apiService.editLocation(obj).subscribe(
      resp => {
        this.globalService.hideSpinner();
        if (resp.status == 1) {
          this.locationName = '';
          this.updateLocationAddress = '';
          this.selectedLocation = {
            location_name: '',
            name: '',
            placeId: '',
            reference: ''
          };
          this.toastr.clear();
          this.toastr.success(resp.message, 'Success');
          this.locationModal.nativeElement.click();

          this.dataTransferService.updateEditLocation(1);
        } else {
          this.toastr.clear();
          this.toastr.error(resp.message, 'Error');
        }
      },
      error => {
        this.globalService.hideSpinner();
        this.toastr.clear();
        this.toastr.warning(error.message, 'Warning');
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/components/location-modal/location-modal.component.ts